import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

import style from './index.scss';

class DismissBar extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);

    this.state = {
      showMore: false
    };
  }

  customizedAxisTick = (props) => {
    const { x, y, stroke, payload } = props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={-5}
          y={-2}
          dy={16}
          textAnchor="end"
          fill="#666"
          transform="rotate(0)">
          {payload.value}
        </text>
      </g>
    );
  };

  parseDomain = (data) => {
    return [
      Math.min.apply(null, [...data.map((entry) => entry.value)]),
      Math.max.apply(null, [...data.map((entry) => entry.value)])
    ];
  };

  toggleMore = () => {
    this.setState({
      ...this.state,
      showMore: !this.state.showMore
    });

    if (this.props.onShowMore) {
      this.props.onShowMore();
    }
  };

  renderTooltip = (props) => {
    const { active, payload } = props;

    if (active && payload && payload.length) {
      const data = payload[0].payload;

      return (
        <div
          style={{
            backgroundColor: '#fff',
            border: '1px solid #999',
            margin: 0,
            padding: 10
          }}>
          <p>{data.date}</p>
          <p>
            <span>Alerts: </span>
            {data.value}
          </p>
        </div>
      );
    }

    return null;
  };

  render() {
    const { type, message, cb } = this.props;
    const { showMore } = this.state;

    const data = [
      { date: '2017-05', value: 110 },
      { date: '2017-06', value: 103 },
      { date: '2017-07', value: 102 },
      { date: '2017-08', value: 105 },
      { date: '2017-09', value: 110 },
      { date: '2017-10', value: 103 },
      { date: '2017-11', value: 102 },
      { date: '2017-12', value: 105 },
      { date: '2018-01', value: 110 },
      { date: '2018-02', value: 103 },
      { date: '2018-03', value: 102 },
      { date: '2018-04', value: 105 },
      { date: '2018-05', value: 122 },
      { date: '2018-06', value: 182 }
    ];

    return (
      <div className="card alert alert-danger ">
        <div
          className="alert-dismissible fade show"
          role="alert"
          style={{ marginBottom: '0' }}>
          <strong>
            <i className="fa fa-exclamation-triangle fa-2x" /> &nbsp; {type}!
          </strong>{' '}
          {message}
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
            onClick={cb}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          className="card-body"
          style={{ display: showMore ? 'block' : 'none' }}>
          <ResponsiveContainer width="90%" height={280}>
            <LineChart mmargin={{ top: 20, right: 30, left: 30, bottom: 10 }}>
              <CartesianGrid strokeDasharray="5 5" />
              <XAxis
                type="category"
                dataKey="date"
                interval={0}
                tick={this.customizedAxisTick}
                tickLine={{ transform: 'translate(0, -5)' }}
              />
              <YAxis type="number" dataKey="value" name="Alerts" />
              <Legend />
              <Tooltip
                cursor={{ strokeDasharray: '3 3' }}
                wrapperStyle={{ zIndex: 100 }}
                content={this.renderTooltip}
              />
              <Line
                type="monotone"
                data={data}
                dataKey="value"
                name="Alerts"
                stroke="#aa0000"
                dot={{ stroke: 'red', strokeWidth: 3 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className={classnames(style.indicator)}>
          <span className={style.indicator}>
            <i
              className={classnames(
                'fa fa-2x',
                showMore ? 'fa-angle-double-up' : 'fa-angle-double-down'
              )}
              onClick={this.toggleMore}></i>
          </span>
        </div>
      </div>
    );
  }
}

DismissBar.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  cb: PropTypes.func
};

export default DismissBar;
